<template>
  <HeaderTitle back-target="challenges">
    <template #top>{{ t("challenge.history.title") }}</template>
    <template #bottom>{{ t("challenge.history.subtitle") }}</template>
  </HeaderTitle>
  <ChallengeTileGrid
    v-if="history.length > 0"
    :challenges="history"
    grid-type="history"
  />
  <div v-else class="text-center mt-8">
    {{ t("challenges.tab.history.button.empty.label") }}
  </div>
</template>
<script setup lang="ts">
import HeaderTitle from "../../../components/v2/layout/header/HeaderTitle.vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
import { ref } from "vue";
import { ChallengeType } from "../../../enum/v2/challengeType.ts";
import { fetchHistory } from "../../../api/v2/custom-challenge.ts";
import { CustomChallengeListViewDto } from "../../../dto/custom-challenge-list-view.dto.ts";
import { useUserStore } from "../../../store/v2/user.js";
import ChallengeTileGrid from "../../../components/v2/challanges/ChallengeTileGrid.vue";
import { ActivityType } from "../../../enum/v2/activityType.ts";

const history = ref(<CustomChallengeListViewDto[]>[]);
const user = useUserStore();

onMounted(() => {
  getHistory();
});

async function getHistory() {
  const res = await fetchHistory(user.externalUserId);
  if (res.data) {
    history.value = res.data.map((challenge: any) => {
      return {
        ...challenge,
        category: challenge.type,
      };
    });
  }
}
</script>
